import { ReactComponent as Facebook } from "./Facebook.svg";
import { ReactComponent as Github } from "./Github.svg";
import { ReactComponent as Instagram } from "./Instagram.svg";
import { ReactComponent as LinkedIN } from "./LinkedIN.svg";

export const socialIcons = {
  Github: Github,
  Facebook: Facebook,
  Instagram: Instagram,
  LinkedIN: LinkedIN
};